import React, {useEffect, useState} from 'react';
import FileUploadSection from "../../../../../components/FileUploadSection/FileUploadSection";
import {Col} from "react-bootstrap";
import {t} from "react-switch-lang";
import {FormProvider, useForm} from "react-hook-form";
import {useParams} from "react-router-dom";
import allowedFileTypes from '../../../../../utils/allowedFileTypes';
import {
  deleteFile, downloadFile,
  uploadMonitoringFile
} from '../../../../../services/externalizations/fileUploadService';
import {Toast} from '../../../../../utils/sweetAlert';
import {getMonitoringFiles} from "../../../../../services/externalizations/externalizationService";
import FilePreview from "../../../../../components/FilePreview/FilePreview";

function Monitoring({cycleId, isLastCycle}) {
  const [files, setFiles] = useState({});
  const [fetchedFiles,setFetchedFiles] = useState([]);
    const { id } = useParams();
  const methods = useForm({});

  useEffect(() => {
    let isMounted = true;

    const fetchMonitoringFiles = async () => {
      try {
        const res = await getMonitoringFiles(id, cycleId);
        if (isMounted) {
          setFetchedFiles(res.data);
        }
      } catch (err) {
        console.error('Error fetching monitoring files', err);
      }
    };

    fetchMonitoringFiles();

    return () => {
      isMounted = false;
    };
  }, [id, cycleId]);

  const handleFileUpload = async (e, fieldName) => {
    const file = e?.target?.files[0];
    if (!file) return null;
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await uploadMonitoringFile(id,formData);
      setFetchedFiles(prev => ([
          ...prev,
        {
          ...response.data
        }
      ]));
      return response;
    } catch (error) {
      console.error("Upload error", error);
    }
  };

  const handleFileUploadExternal = async (newFiles, fieldName) => {
    const fileInput = document.getElementById(`upload-${fieldName}`);
    if (!fileInput || !fileInput.files.length) return;
    const selectedFile = fileInput.files[0];
    const existingFile = files[fieldName];
    if (existingFile?.id) {
      try {
        await deleteFile(existingFile?.id);
      } catch (err) {
        console.error('error', err);
      }
    }
    const response = await handleFileUpload({ target: { files: [selectedFile] } }, fieldName);

    if (response?.status === 201) {
      Toast.fire({
        title: existingFile
          ? t('message.updateSuccess2', { entity: t('externalization.riskProponentForm.file') })
          : t('message.addSuccess2', { entity: t('externalization.riskProponentForm.file') }),
        icon: 'success',
      });
    }
  };

  const removeFile = async (fieldName, fileId) => {
    try {
      const id = fileId || files[fieldName]?.id;
      if (!id) return;

      const response = await deleteFile(id);

      if (response?.status === 204) {
        Toast.fire({
          title: t('message.deleteSuccess2', {
            entity: t('externalization.riskProponentForm.file'),
          }),
          icon: 'success',
        });

        if (fileId) {
          setFetchedFiles(prev => prev.filter(f => f.id !== fileId));
        } else {
          setFiles(prev => ({ ...prev, [fieldName]: null }));
        }
      }
    } catch (error) {
      console.error("error", error);
    }
  };
  const handleDownload = (attachmentId, fileName) => {
       downloadFile(attachmentId,fileName);
  };

    return (
        <FormProvider {...methods}>
            <form>
        <Col>
          <div className={"w-25"}>
            <label style={{minHeight: '50px'}} className="label d-flex align-items-end w-100 mt-2">
              {t('common.addFile')}
            </label>
          <FileUploadSection
            className={'fileName'}
            fieldName={'taxClearance'}
            key={files?.taxClearance?.id}
            allowedFileTypes={allowedFileTypes}
            disabled={!isLastCycle}
            required={false}
            multiple={false}
            showLocalFiles={false}
            fetchedFiles={
              files?.taxClearance
                ? [{ id: files?.taxClearance?.id, fileName: files?.taxClearance?.name }]
                : []
            }
            onDeleteFetchedFile={() => removeFile('taxClearance')}
            onNewFilesChange={(newFiles) =>
              handleFileUploadExternal(newFiles, 'taxClearance', 'tax-clearance')
            }
            onFileDownload={(id, fileName) =>
              handleDownload(files?.taxClearance?.id, fileName)
            }
          />
          </div>
          <div className="d-flex flex-wrap justify-content-start">
            {fetchedFiles.map((file) => (
                <div key={file.id} style={{ minWidth: "200px",maxWidth: 'fit-content', flex: "1 1 200px", margin: "8px" }}>
                  <FilePreview file={file} removeFile={removeFile} fileDownload={handleDownload} />
                </div>
            ))}
          </div>
        </Col>
            </form>
        </FormProvider>
    );
}

export default Monitoring;